import React from 'react'
import { useSelector } from 'react-redux'

import MetabarContainer from './Container'
import { isOnboardingOnInviteStep } from 'screens/OnboardingPopover/utils'

export default React.memo(function Metabar() {
  const isOnboarding = useSelector(isOnboardingOnInviteStep)

  if (isOnboarding) {
    return null
  }

  return <MetabarContainer />
})
